import { render, staticRenderFns } from "./PendenciasPraticasGraphic.vue?vue&type=template&id=0d0df335&scoped=true"
import script from "./PendenciasPraticasGraphic.vue?vue&type=script&lang=js"
export * from "./PendenciasPraticasGraphic.vue?vue&type=script&lang=js"
import style0 from "./PendenciasPraticasGraphic.vue?vue&type=style&index=0&id=0d0df335&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0df335",
  null
  
)

export default component.exports